export function getCommentButtonLabel(localizedLabel: string, numberOfComments?: number){
  return `${localizedLabel} [${numberOfComments || 0}]`;
}
